import {useMutation} from "@tanstack/react-query";
import {createRoleMutationOptions} from "./create-role.mutation-options";

export function useCreateRole() {
  return useMutation(createRoleMutationOptions());
}
